import React from 'react';
import { Calendar, globalizeLocalizer } from 'react-big-calendar';
import globalize from 'globalize';
import './styleCalenderView.css';
import WeekView from '../Weekview/WeekView';
import moment from 'moment';

const localizer = globalizeLocalizer(globalize);

const CalenderView = () => {
    const culture = globalize.culture('en-US');
    culture.calendar.firstDay = 1;

    let labelData = [];

    const renderCustomMonthCell = (date) => {
        if (!date) {
            return <div className='rbc-day-bg'>No date</div>;
        }

        const dateString = date.value + "";
        const dateSplit = dateString.split(" ");
        const calendarDay = dateSplit[2].toString();
        const newDate = new Date();
        const listDate = newDate.toString().split(" ");
        const getToday = listDate[2].toString();
        const currentMonth = dateSplit[1].toString() + dateSplit[3].toString();
        const todayMonth = listDate[1].toString() + listDate[3].toString();
        const isToday = calendarDay === getToday && currentMonth === todayMonth;
        if (!labelData[1].includes(dateSplit[1])) {
            if (dateSplit[0] === "Sun") {
                return <div className='rbc-day-bg off-day sunday-block'></div>
            }
            return <div className='rbc-day-bg off-day'></div>
        }
        if (dateSplit[0] === "Sun") {
            return (
                <div className='rbc-day-bg sunday-block'></div>
            )
        }

        return (
            <div className='rbc-day-bg'>
                <div className='innerDiv-day' style={{ background: isToday ? '#FFF6DF' : 'none' }}>
                    <div className='innerDiv-addTask'>
                        <svg width="10" height="10" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0.4 3C0.4 1.56406 1.56406 0.4 3 0.4C4.43594 0.4 5.6 1.56406 5.6 3C5.6 4.43594 4.43594 5.6 3 5.6C1.56406 5.6 0.4 4.43594 0.4 3ZM3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0ZM3 1.63636C3.15062 1.63636 3.27273 1.72358 3.27273 1.83117V2.72727H4.16883C4.27642 2.72727 4.36364 2.84938 4.36364 3C4.36364 3.15062 4.27642 3.27273 4.16883 3.27273H3.27273V4.16883C3.27273 4.27642 3.15062 4.36364 3 4.36364C2.84938 4.36364 2.72727 4.27642 2.72727 4.16883V3.27273H1.83117C1.72358 3.27273 1.63636 3.15062 1.63636 3C1.63636 2.84938 1.72358 2.72727 1.83117 2.72727H2.72727V1.83117C2.72727 1.72358 2.84938 1.63636 3 1.63636Z" fill="#263238" />
                        </svg>
                        <p>Add Task</p>
                    </div>
                    <div className='innerDivTask'>
                        <div className='taskDiv'>
                            <div className='taskDiv-half-container'>
                                <div className="status"></div>
                                <p>Coffee app edits</p>
                            </div>
                        </div>
                        <div className='taskDiv'>
                            <div className='taskDiv-half-container'>
                                <div className="status"></div>
                                <p>Coffee app edits</p>
                            </div>
                        </div>
                        <div className='taskDiv'>
                            <div className='taskDiv-half-container'>
                                <div className="status"></div>
                                <p>Coffee app edits</p>
                            </div>
                        </div>
                    </div>
                    <div className='innerDiv-moreTask'></div>
                </div>
            </div>
        );
    };


    const CustomMonthCell = React.memo(renderCustomMonthCell);

    const CustomToolbar = (toolbar) => {
        const { label, onView, onNavigate, view, date } = toolbar;
        const month = label.split(' ');
        labelData = month
        const dateString = toolbar.date + "";
        const dateSplit = dateString.split(" ");
        const calendarDay = dateSplit[2].toString();
        const newDate = new Date();
        const listDate = newDate.toString().split(" ");
        const getToday = listDate[2].toString();
        const currentMonth = dateSplit[1].toString() + dateSplit[3].toString();
        const todayMonth = listDate[1].toString() + listDate[3].toString();
        const isToday = calendarDay === getToday && currentMonth === todayMonth;
        const weekNumberInMonth = moment(toolbar.date).isoWeek() - moment(toolbar.date).startOf('month').isoWeek() + 1;
        if (view === "month") {
            return (
                <div className='monthView-toolbar'>
                    <div className='label'>
                        <svg onClick={() => onNavigate("PREV")} width="10" height="15" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.19231 0L6 0.916667L1.73077 5.5L6 10.0833L5.19231 11L4.76837e-07 5.5L5.19231 0Z" fill="#FF8402" />
                        </svg>
                        &nbsp;
                        <div className='label-container'>{month[1]}, {month[0]}</div>
                        &nbsp;
                        <svg onClick={() => onNavigate("NEXT")} width="10" height="15" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.807692 0L0 0.916667L4.26923 5.5L0 10.0833L0.807692 11L6 5.5L0.807692 0Z" fill="#FF8402" />
                        </svg>
                        {/* <ShortCalender sendDataToParent={handleChildData} currentDate={currentDate} /> */}
                    </div>
                    <div className='viewBtns'>
                        <button className='todayView-btn' style={{ background: isToday ? '#FFF6DF' : 'none' }} onClick={() => onNavigate('TODAY')}>today</button>
                        <button className='monthView-btn monthView-btn-view' style={{ background: view === "month" ? '#FFF6DF' : 'none' }} onClick={() => onView('month')}>Month</button>
                        <button className='weekView-btn monthView-btn-view' style={{ background: view === "week" ? '#FFF6DF' : 'none' }} onClick={() => onView('week')}>Week</button>
                        <button className="dayView-btn monthView-btn-view" style={{ background: view === "day" ? '#FFF6DF' : 'none' }} onClick={() => onView('day')}>Day</button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className='monthView-toolbar'>
                    <div className='labels-container'>
                        <div className='label'>
                            <svg onClick={() => onNavigate("NEXT", moment(date).subtract(1, 'months').toDate())} width="10" height="15" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.19231 0L6 0.916667L1.73077 5.5L6 10.0833L5.19231 11L4.76837e-07 5.5L5.19231 0Z" fill="#FF8402" />
                            </svg>
                            &nbsp;
                            <div className='label-container'>{moment(toolbar.date).format('MMMM')}, {dateSplit[3]}</div>
                            &nbsp;
                            <svg onClick={() => onNavigate("PREV", moment(date).add(1, 'months').toDate())} width="10" height="15" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.807692 0L0 0.916667L4.26923 5.5L0 10.0833L0.807692 11L6 5.5L0.807692 0Z" fill="#FF8402" />
                            </svg>
                            {/* <ShortCalender sendDataToParent={handleChildData} currentDate={currentDate} /> */}
                        </div>
                        <div className='weekLabel'>
                            <svg onClick={() => onNavigate("PREV")} width="10" height="15" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.19231 0L6 0.916667L1.73077 5.5L6 10.0833L5.19231 11L4.76837e-07 5.5L5.19231 0Z" fill="#FF8402" />
                            </svg>
                            &nbsp;
                            <div className='weekLabel-container'>Week {weekNumberInMonth}</div>
                            &nbsp;
                            <svg onClick={() => onNavigate("NEXT")} width="10" height="15" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.807692 0L0 0.916667L4.26923 5.5L0 10.0833L0.807692 11L6 5.5L0.807692 0Z" fill="#FF8402" />
                            </svg>
                        </div>
                    </div>
                    <div className='viewBtns'>
                        <button className='todayView-btn' style={{ background: isToday ? '#FFF6DF' : 'none' }} onClick={() => onNavigate('TODAY')}>today</button>
                        <button className='monthView-btn monthView-btn-view' style={{ background: view === "month" ? '#FFF6DF' : 'none' }} onClick={() => onView('month')}>Month</button>
                        <button className='weekView-btn monthView-btn-view' style={{ background: view === "week" ? '#FFF6DF' : 'none' }} onClick={() => onView('week')}>Week</button>
                        <button className="dayView-btn monthView-btn-view" style={{ background: view === "day" ? '#FFF6DF' : 'none' }} onClick={() => onView('day')} >Day</button>
                    </div>
                </div>
            );
        }
    };

    const CostomWeekcell = (e) => {
        return <WeekView props={e} />
    }

    const CustomDay = (e) => {
        return <div>jhsdfjhgb</div>
    }

    return (
        <Calendar
            localizer={localizer}
            events={[]}
            startAccessor="start"
            endAccessor="end"
            // defaultDate={currentDate}
            cultures={{ 'en-US': culture }}
            components={{
                toolbar: CustomToolbar,
                month: {
                    dateCellWrapper: CustomMonthCell,
                },
                week: {
                    header: CostomWeekcell,
                },

                day:  CustomDay 
                    
                
            }}
        />
    );
};

export default CalenderView;
